import { useEffect, useState } from 'react';
import { useAuth } from '../api.js';

/** Whether the account has uploaded a statement / set rates yet — drives the
 *  dashboard onboarding checklist AND the nav "bubble" callouts on Files/Rates. */
export interface SetupState {
  uploaded: boolean;
  rated: boolean;
  loaded: boolean;
}

export function useSetupState(): SetupState {
  const { client } = useAuth();
  const [s, setS] = useState<SetupState>({ uploaded: false, rated: false, loaded: false });
  useEffect(() => {
    let live = true;
    Promise.all([
      client
        .listFiles({ limit: 1 })
        .then((r) => r.data.length > 0)
        .catch(() => false),
      client
        .listExpectedRates()
        .then((r) => r.data.length > 0)
        .catch(() => false),
    ]).then(([uploaded, rated]) => {
      if (live) setS({ uploaded, rated, loaded: true });
    });
    return () => {
      live = false;
    };
  }, [client]);
  return s;
}
